import SimplePriceComparison from './SimplePriceComparison';

/** Legacy route `/products/:productId` : same UI as `/compare/:productIds`. */
export default SimplePriceComparison;
